// extracted by mini-css-extract-plugin
module.exports = {"title":"answer_title__3q0ou","with-status":"answer_with-status__3g-GH","import-button":"answer_import-button__LKuxF"};